exports = module.exports = require("../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._1esYxK9SDOe2Htw4yyAAkJ{text-decoration:line-through}", ""]);
// Exports
exports.locals = {
	"strikethrough": "_1esYxK9SDOe2Htw4yyAAkJ"
};